import { ApiError } from "@frontend/lib/http";

export async function untilFound<T>(
  fetch: () => Promise<T>,
  delays: readonly number[],
  signal?: AbortSignal,
): Promise<T> {
  for (const delay of [...delays, 0]) {
    try {
      return await fetch();
    } catch (error) {
      if (!(error instanceof ApiError) || 404 !== error.status || 0 === delay) {
        throw error;
      }

      await pause(delay, signal);
    }
  }

  throw new ApiError(404, "Not found");
}

function pause(delay: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(resolve, delay);

    signal?.addEventListener("abort", () => {
      clearTimeout(timer);
      reject(new DOMException("Aborted", "AbortError"));
    });
  });
}
